import api from './api';

export const createSurvey = async (data) => {
  const response = await api.post(`/survey`, data);
  return response.data;
};

export const fetchAllSurveys = async ({ queryKey }) => {
  const [, { page, limit, search, searchBy, searchByExactMatch }] = queryKey;
  let url = `/survey?page=${page}&limit=${limit}`;

  if (search) {
    url += `&search=${search}`;
  }
  if (searchBy && Array.isArray(searchBy)) {
    const params = searchBy.map((field) => `searchBy=${field}`).join('&');
    url += `&${params}`;
  }
  if (searchByExactMatch) {
    url += `&searchByExactMatch=${searchByExactMatch}`;
  }

  const response = await api.get(url);
  return response.data;
};

export const fetchSurvey = async ({ queryKey }) => {
  const [, id] = queryKey;
  const response = await api.get(`/survey/${id}`);
  return response.data;
};

export const fetchSurveyResponses = async ({ queryKey }) => {
  const [, { id, page, limit, search, searchBy, searchByExactMatch }] = queryKey;
  let url = `/survey/${id}/responses?page=${page}&limit=${limit}`;

  if (search) {
    url += `&search=${search}`;
  }
  if (searchBy && Array.isArray(searchBy)) {
    const params = searchBy.map((field) => `searchBy=${field}`).join('&');
    url += `&${params}`;
  }
  if (searchByExactMatch) {
    url += `&searchByExactMatch=${searchByExactMatch}`;
  }

  const response = await api.get(url);
  return response.data;
};

export const deleteSurvey = async (id) => {
  const response = await api.delete(`/survey/${id}`);
  return response.data;
};

export const updateSurvey = async (id, data) => {
  const response = await api.patch(`/survey/${id}`, data);
  return response.data;
};

export const publishSurvey = async (id) => {
  const response = await api.post(`/survey/${id}/push`);
  return response.data;
};

export const exportSurvey = async (data) => {
  const response = await api.post(`/export/survey`, data);
  return response.data;
};
